import { useCallback } from 'react'
import { message } from 'antd'

export const useExport = () => {
    const exportToCSV = useCallback((data: any[], filename: string) => {
        try {
            if (!data || data.length === 0) {
                message.warning('No data to export')
                return
            }

            // Get headers from first object
            const headers = Object.keys(data[0])
            
            // Create CSV content
            const csvContent = [
                headers.join(','),
                ...data.map(row => 
                    headers.map(header => {
                        const cell = row[header]
                        return typeof cell === 'string' ? `"${cell.replace(/"/g, '""')}"` : cell
                    }).join(',')
                )
            ].join('\n')

            // Create blob and download link
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const link = document.createElement('a')
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob)
                link.setAttribute('href', url)
                link.setAttribute('download', `${filename}.csv`)
                link.style.visibility = 'hidden'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                message.success('Export successful')
            }
        } catch (error) {
            console.error('Export failed:', error)
            message.error('Export failed')
        }
    }, [])

    return { exportToCSV }
}
